<!--
 * @Descripttion: 
 * @version: v1
 * @Author: liukx
 * @Date: 2022-05-01 23:09:12
 * @LastEditors: ???
 * @LastEditTime: 2022-05-11 22:33:54
-->
<template>
  <div class="wrapper">
    <el-dialog
      :close-on-click-modal="visible"
      :title="title"
      :visible.sync="visible"
      width="30%"
      @close="close"
    >
      <el-form :model="ledgerDetail" ref="form" size="small" label-width="100px">
        <el-form-item label="台账编号">
          <el-input :value="ledgerDetail.ledgerNo" readonly></el-input>
        </el-form-item>
        <el-form-item label="台账日期">
          <el-input :value="ledgerDetail.ledgerDate" readonly></el-input>
        </el-form-item>
        <el-form-item label="录入人">
          <el-input :value="userList[ledgerDetail.createUser]" readonly></el-input>
        </el-form-item>
        <el-form-item label="清理人">
          <el-input :value="userList[ledgerDetail.cleanUserId]" readonly></el-input>
        </el-form-item>
        <el-form-item label="台账位置">
          <el-input type="textarea" :value="ledgerDetail.ledgerPosition" autosize readonly></el-input>
        </el-form-item>
        <el-form-item label="台账照片">
          <template v-if="ledgerDetail.ledgerPic">
            <el-image
              v-for="(item, i) in ledgerDetail.ledgerPic"
              style="width: 100px; height: 50px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="清理后照片">
          <template v-if="ledgerDetail.cleanPic">
            <el-image
              v-for="(item, i) in ledgerDetail.cleanPic"
              style="width: 100px; height: 50px"
              :src="item"
              :preview-src-list="[item]"
              :key="i"
            >
              <div slot="error" class="image-slot" style="width: 100px; height: 50px">
                <img src="@/assets/imgFail.png" alt style="width: 60px; height: 40px" />
              </div>
            </el-image>
          </template>
        </el-form-item>
        <el-form-item label="分配时间">
          <el-input :value="ledgerDetail.assignTime" readonly></el-input>
        </el-form-item>
        <el-form-item label="接收时间">
          <el-input :value="ledgerDetail.acceptTime" readonly></el-input>
        </el-form-item>
        <el-form-item label="完成时间">
          <el-input :value="ledgerDetail.doneTime" readonly></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :value="ledgerDetail.remark" autosize readonly></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-input :value="ledgerTypeCode[ledgerDetail.status]" readonly></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['ledgerDetail', 'userList'],
  data () {
    return {
      title: '详情',
      visible: false,
      ledgerTypeCode: {
        1: '待分配',
        2: '已分配',
        3: '处理中',
        4: '已完成',
      },
    }
  },
  watch: {},
  computed: {},
  methods: {
    add () {
      this.visible = true
      console.log(this.userList);
    },
    close () {
      this.visible = false
    },
  },
  created () { },
  mounted () {
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  .menuBar {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    /*height: calc(100% - 100px);*/
    height: 300px;
    overflow-y: auto;
  }
}
</style>
